export default {
  english: 'الإنجليزية',
  arabic: 'العربية',
  login: 'تسجيل الدخول',
  cart: 'سلة المشتريات',
  sidebar: {
    dashboard: 'لوحة التحكم',
    products: 'المنتجات',
    orders: 'طلبات',
    offers: 'العروض',
    withdraw: 'سحب',
    reviews: 'التعليقات',
    categories: 'الأقسام',
    discount: 'خصومات',
    collection: 'المجموعات',
    processing: 'فى الإنتظار',
    settings: 'الضبط',
    collections: 'مجموعات',
    books: 'الحجوزات',
    financialOperations: 'العمليات المالية',
    withdrawalRequests: 'طلبات السحب',
    doctors: 'الأطباء'

  }
}
